import React, { useEffect } from "react";
import clsx from "clsx";
import "./SummaryConfig.css";
import ConfigureLuvers from "./ConfigureLuvers";
import {
  TextField,
  createMuiTheme,
  InputAdornment,
  MuiThemeProvider,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "",
  },
}));

const theme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      root: {
        // "&$focused": {
        //   color: "#C34720",
        //   fontWeight: "bold",
        // },
      },
      focused: {},
    },
    MuiInputBase: {
      root: {
        "&$focused": {
          borderColor: "#C34720",
        },
      },
    },
  },
});

function SummaryConfig(props: any) {
  const classes = useStyles();

  // Set count of top luvers dependence on lenght
  useEffect(() => {
    let count;
    if (props.konfigured['luvers'] === 'BEZ_OCZEK') {
      count = 0
    } else {
      const recomendedDistanceBetween = 50;
      count = Math.floor(
        props.konfigured["length"] / recomendedDistanceBetween
      );
    }
   
    props.setLuversCount(count, "top_luvers_count");
  }, [props.konfigured["length"]]);


  // Set count of left/right luvers dependence on width

  useEffect(() => {
    let count;
    if (props.konfigured['luvers'] === 'BEZ_OCZEK') {
      count = 0
    } else {
      const recomendedDistanceBetween = 50;
    count = Math.floor(
      props.konfigured["width"] / recomendedDistanceBetween
    );
    }
    props.setLuversCount(count, "left_luvers_count");
    props.setLuversCount(count, "right_luvers_count");
  }, [props.konfigured["width"]]);

  return (
    <div className="summary-config">
      <h2>Rozmiar: </h2>
      <MuiThemeProvider theme={theme}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <TextField
              label="Szerokość"
              id="standard-start-adornment"
              type="number"
              name="width"
              value={props.konfigured.width}
              onChange={(e) => props.onSelectChange(e)}
              className={clsx(classes.textField)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">Cm</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="length"
              label="Długość"
              id="standard-start-adornment"
              type="number"
              value={props.konfigured.length}
              onChange={(e) => props.onSelectChange(e)}
              className={clsx(classes.textField)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">Cm</InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <h2>Kąt: </h2>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <TextField
              label="Lewo kąt"
              id="standard-start-adornment"
              type="number"
              name="top_left_angle"
              value={props.konfigured.top_left_angle}
              onChange={(e) => props.onSelectChange(e)}
              className={clsx(classes.textField)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">Cm</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="top_right_angle"
              label="Pravo kąt"
              id="standard-start-adornment"
              type="number"
              value={props.konfigured.top_right_angle}
              onChange={(e) => props.onSelectChange(e)}
              className={clsx(classes.textField)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">Cm</InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        {props.konfigured["window"] !== "bez_okna" ? (
          <div>
            {" "}
            <h2>Okno: </h2>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <TextField
                  label="Szerokość"
                  id="standard-start-adornment"
                  type="number"
                  name="window_width"
                  value={props.konfigured["window_width"]}
                  onChange={(e) => props.onSelectChange(e)}
                  className={clsx(classes.textField)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Cm</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="window_length"
                  label="Długość"
                  id="standard-start-adornment"
                  type="number"
                  value={props.konfigured["window_length"]}
                  onChange={(e) => props.onSelectChange(e)}
                  className={clsx(classes.textField)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Cm</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Szczyt"
                  id="standard-start-adornment"
                  type="number"
                  value={props.konfigured["top_window_distace"]}
                  name="top_window_distace"
                  onChange={(e) => props.onSelectChange(e)}
                  className={clsx(classes.textField)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Cm</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Prawo"
                  id="standard-start-adornment"
                  type="number"
                  value={props.konfigured["right_window_distace"]}
                  name="right_window_distace"
                  onChange={(e) => props.onSelectChange(e)}
                  className={clsx(classes.textField)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Cm</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Lewo"
                  id="standard-start-adornment"
                  type="number"
                  value={props.konfigured["left_window_distace"]}
                  name="left_window_distace"
                  onChange={(e) => props.onSelectChange(e)}
                  className={clsx(classes.textField)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Cm</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Spód"
                  id="standard-start-adornment"
                  type="number"
                  value={props.konfigured["bottom_window_distace"]}
                  name="bottom_window_distace"
                  onChange={(e) => props.onSelectChange(e)}
                  className={clsx(classes.textField)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Cm</InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </div>
        ) : (
          ""
        )}

        {props.konfigured["luvers"] !== "BEZ_OCZEK" ? (
          <ConfigureLuvers
            luverSelects={props.luverSelects}
            konfigured={props.konfigured}
            onSelectChange={props.onSelectChange}
          ></ConfigureLuvers>
        ) : (
          ""
        )}
      </MuiThemeProvider>
    </div>
  );
}

export default SummaryConfig;
